import { GoogleMapsCore } from "../../../../components/googleMaps/GoogleMapsCore/GoogleMapsGeneral";

export const GoogleMaps = () => {
  return (
    <GoogleMapsCore type="settings" />
  )
}